"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.shiftMonth = void 0;
const shiftMonth = (currentShownMonth, value) => {
    const nextMonthDate = new Date(currentShownMonth.year, currentShownMonth.month + value, 1);
    return {
        year: nextMonthDate.getFullYear(),
        month: nextMonthDate.getMonth()
    };
};
exports.shiftMonth = shiftMonth;
//# sourceMappingURL=shiftMonth.js.map